import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import { MEDIA_URL } from 'reservations/base/constants/bentobox';
import BookingConfirmationDetailCard from 'reservations/confirmation/components/BookingConfirmationDetailCard';

const Image = styled('img')({
  position: 'relative',
  height: 'auto',
  width: '100%',
  maxHeight: '560px',
  maxWidth: '560px',
  objectFit: 'cover',
  aspectRatio: '1 / 1'
});

type Props = {
  context: {
    altText: string;
    body: string;
    header: string;
    url: string;
    button: {
      isEnabled: boolean;
      buttonLink: string;
      buttonText: string;
    };
  };
};

const ImageModule = ({ context }: Props) => {
  const { altText, body, header, url, button } = context;
  const { isEnabled, buttonLink, buttonText } = button;

  const redirectToLink = () => {
    if (buttonLink.startsWith('/') || buttonLink.startsWith('http')) {
      window.open(buttonLink, '_blank');
    } else {
      window.open('https://' + buttonLink, '_blank');
    }
  };

  return (
    <BookingConfirmationDetailCard header={header}>
      <Image src={`${MEDIA_URL}/${url}`} alt={altText} />
      <Typography>{body}</Typography>
      {isEnabled && (
        <Box>
          <Button data-testid="image-module-button" onClick={redirectToLink}>
            {buttonText}
          </Button>
        </Box>
      )}
    </BookingConfirmationDetailCard>
  );
};

export default ImageModule;
